import { useCallback, useEffect, useState } from 'react';
import { getPartners } from '../api/digiscore-api';

export default function usePartners({ token, shouldFetch, onBusyChange }) {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    let cancelled = false;
    if (!shouldFetch) return;

    (async () => {
      try {
        onBusyChange?.(true);
        const data = await getPartners(token);
        if (cancelled) return;
        setPartners(data.map(p => ({ ...p, checked: !!p.checked })));
      } catch (err) {
        console.error('Error fetching partners:', err);
      } finally {
        onBusyChange?.(false);
      }
    })();

    return () => { cancelled = true; };
  }, [token, shouldFetch, onBusyChange]);

  const togglePartner = useCallback((id) => {
    setPartners(prev =>
      prev.map(p => (p.id === id ? { ...p, checked: !p.checked } : p))
    );
  }, []);

  const selectedIds = partners.filter(p => p.checked).map(p => p.id);

  return { partners, togglePartner, selectedIds };
}